import React, { useEffect, useState } from 'react'
import Container from '../../../v2/Container'
import Image from '../../../Image'
import landingPageImg from '../../../../assets/panorama-landing-page.jpg'
import useQueryString from '../../../../hooks/use-query-string'
import { Package, Price, Student, Djob } from '../../../../models'
import Fetching from './Fetching'
import ErrorState from './ErrorState'
import YearbookForm from '././PanoramaForm'
import useLocalStorage from '../../../../hooks/useLocalStorage';
import Typography from '../../../Typography';

const ERROR = 'ERROR'
const DONE = 'DONE'
const FETCHING = 'FETCHING'
const TOO_MANY_RESULTS = 'TOO_MANY_RESULTS'

export const useStudent = (params) => {
  const [student, setStudent] = useState()
  const [status, setStatus] = useState(FETCHING)

  useEffect(() => {
    setStatus(FETCHING)

    Student
      .includes('school')
      .where({ ...params })
      .all()
      .then((res) => {
        if (res.data.length === 1) {
          setStudent(res.data[0])
          setStatus(DONE)
        } else {
          setStudent(res.data[res.data.length - 1])
          setStatus(DONE)
        }
      })
      .catch(() => {
        setStatus(ERROR)
      })
  }, [params.studentId, params.schoolId])

  return { student, status }
}

export const usePanoramaPackage = (schoolId) => {
  const [yearbook, setYearbook] = useState()
  const [yearbooks, setYearbooks] = useState([])
  const [status, setStatus] = useState(FETCHING)

  useEffect(() => {
    if (!schoolId) return

    const priceScope = Price.where({ for_school: schoolId })

    Package
      .includes({ options: { prices: 'school' } })
      .merge({ prices: priceScope })
      .where({ schoolId })
      .where({ has_prices_for_school: schoolId })
      .where({ name: { match: 'panorama' } })
      .all()
      .then((res) => {
        if (res.data.length < 1) return

        setYearbooks(res.data)
        setYearbook(res.data[0])
      })
  }, [schoolId])

  return { yearbook, yearbooks, status }
}

export const usePanoramicImage = (schoolId, accessCode) => {
  const [panoramicImage, setPanoramicImage] = useState()

  useEffect(() => {
    if (!schoolId) return
    if (!accessCode) return

    Djob.
      where({ with_panoramic_image: [schoolId, accessCode] })
      .selectExtra(['panoramicImageUrl'])
      .all()
      .then((res) => {
        if (res.data.length < 1) return

        setPanoramicImage(res.data[0].panoramicImageUrl)
      })
  }, [schoolId, accessCode])

  return { panoramicImage }
}

const Yearbooks = () => {
  const { sch: schoolId, sid: studentId, access_code: accessCode } = useQueryString()
  const { student, status } = useStudent({ schoolId, studentId })
  const { yearbook, yearbooks } = usePanoramaPackage(schoolId)
  const { panoramicImage } = usePanoramicImage(schoolId, accessCode)
  const [_, setIsUsingAccessCode] = useLocalStorage('isUsingAccessCode')

  setIsUsingAccessCode(true)

  if (status === FETCHING) return <Fetching />
  if (status === TOO_MANY_RESULTS || status === ERROR) {
    return <ErrorState message="We were unable to find your student. Please check back again later." />
  }

  if (!(student && yearbook)) {
    return (
      <Typography align="center" fontStyle="italic">
        Panoramas are currently not available for your school. Please check back again later.
      </Typography>
    )
  }

  return (
    <Container maxWidth="md">
      <Image src={panoramicImage || landingPageImg} alt="Purchase Panorama Image" />
      <YearbookForm student={student} school={student.school} defaultYearbook={yearbook} yearbooks={yearbooks} />
    </Container>
  )
}

export default Yearbooks
